import { getBackendUrl } from "@Utils";
import axiosWrapper from "@AxiosWrapper";
import type { JiraControllerResponse } from "@ServerTypes/jira/jira.schema";

export const jiraTicketsUrl = `${getBackendUrl()}/jira/jiraController`;

export async function jiraController(data: any) {
  const res = await axiosWrapper.post<JiraControllerResponse>(
    `${process.env.REACT_APP_CUBE_BACKEND}/jira/jiraController`,
    data,
  );
  return res;
}
